import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/Person';
import create from './create';
import edit from './edit';
import list from './list';

const users: ResourceProps = {
  name: 'users',
  icon,
  options: { label: 'Usuários' },
  create,
  edit,
  list
};

export default users;
